/** @format */
import React from 'react';
import { useStyles } from './style';
import { Box } from '@mui/material';

const HeaderSection = ({ title, style = {}, hr = true }) => {
  const classes = useStyles();

  return (
    <Box mt={4} pr={1} className={classes.root} style={{ ...style }}>
      <div className={classes.title}>{title}</div>
      {hr && <hr className={classes.line} />}
    </Box>
  );
};

export default HeaderSection;
